import axios from "axios";
import Vue from "vue";
import { Modal, Message } from "view-design";
import store from "../store/index";
import router from "@/router/index";

// axios 基础配置
// axios.defaults.baseURL = ''
const http = axios.create({
  timeout: 8000 // 设置超时时间
});
//axios 基础配置
// const http = axios.create({
//   timeout: 8000, // 设置超时时间
//   baseURL: process.env.NODE_ENV === 'production' ? 'http://20.191.50.11:6080' : ('/yhy' || '/openapi')
// })
// axios.defaults.baseURL = process.env.VUE_APP_BASE_API;

// console.log(process.env.VUE_APP_BASE_API)
// if (process.env.NODE_ENV === 'production') {
//   http.baseURL = 'http://20.191.50.11:6080'
// }

let refreshSubscribers = [];

/*push所有请求到数组中*/
const subscribeTokenRefresh = cb => {
  refreshSubscribers.push(cb);
};

/*刷新请求（refreshSubscribers数组中的请求得到新的token之后会自执行，用新的token去请求数据）*/
const onRrefreshed = token => {
  refreshSubscribers.map(cb => cb(token));
};

const err = error => {
  if (error.response) {
    const token = Vue.ls.get("token");
    const errorCode = error.response.errorCode;
    const status = error.response.status;
    const errorMessage = error.response.errorMessage;
    // console.log('------异常响应------', token)
    // console.log('------异常响应------', status)
    if (errorCode) {
      Modal.error({
        title: "title",
        content: errorMessage
      });
    }
    if (status === 401) {
      // let url = process.env.VUE_APP_PREFIX + "/refresh";
      const refresh_token = Vue.ls.get("refresh_token");
      // console.log(refresh_token)
      const url = `${process.env.VUE_APP_GATEWAY_URL}/hermes/oauth/token?grant_type=refresh_token&refresh_token=${refresh_token}&client_id=${process.env.VUE_APP_CLIENT_ID}&client_secret=secret`

      axios.post(url).then(res => {
        console.log(res)
        // debugger
        if (res.data.access_token) {
          console.log(111)
          Vue.ls.set("token", res.data.access_token);
          // return http(error.response.config)
          onRrefreshed(res.data.access_token);
          /*执行onRefreshed函数后清空数组中保存的请求*/
          refreshSubscribers = [];
        } else {
          console.log(222)
          Vue.ls.remove("token");
          Vue.ls.remove("type");
          router.push({
            path: "/login",
            query: { redirect: router.history.current.fullPath }
          });
          Message.error("登录超时，请重新登录");
          window.location.reload();
        }
      }).catch(error => {
        console.log(error)
        Vue.ls.remove("token");
        Vue.ls.remove("type");
        router.push({
          path: "/login",
          query: { redirect: router.history.current.fullPath }
        });
        Message.error("登录超时，请重新登录");
        window.location.reload();
      });
      let retry = new Promise((resolve, reject) => {
        /*(token) => {...}这个函数就是回调函数*/
        subscribeTokenRefresh(token => {
          // console.log(error.response.config)
          let url = error.response.config.url;
          if (process.env.VUE_APP_PREFIX) {
            if (url.indexOf(process.env.VUE_APP_PREFIX) === 0) {
              error.response.config.url = url.substr(
                process.env.VUE_APP_PREFIX.length
              );
            }
          }
          error.response.config.headers.Authorization = "bearer " + token;
          /*将请求挂起*/
          http(error.response.config).then(res => resolve(res)); // 之前是res.data
        });
      });
      return retry;
    }
  }
  return Promise.reject(error);
};

// request interceptor
http.interceptors.request.use(
  config => {
    // const token = 'bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyaWQiOiJvajl2cnZ6MmNMcGNieUJlNEtLTEpDaDJDb2M0IiwiaWF0IjoxNTkzMzk4NjI2LCJleHAiOjE1OTM0MDIyMjZ9.wlAioRnJerxTrjrx_qW-kzO8E-uXxqWTgbSBhOrys_U'
    let token = Vue.ls.get('token')
    // let token
    // let tokenCollection = localStorage.getItem("tokenCollection");
    // if (tokenCollection) {
    //   token = JSON.parse(tokenCollection).access_token
    // }
    // console.log(token)
    if (!token) {
      token = Vue.ls.get("temporary");
    }
    //Mod by LiuHui at 20201201 for cros begin
    // if (process.env.NODE_ENV === 'production') {
    //   config.url = process.env.VUE_APP_PREFIX + config.url
    // }
    // if(config.url.startsWith("/openapi")){
    //   config.url = process.env.VUE_APP_OPENAPI_URL + config.url
    // }else if(config.url.startsWith("/api")){
    //   config.url = process.env.VUE_APP_API_URL + config.url.replace(/\/api/, "")
    // } else if (config.url.startsWith("/sqbs")) {
    //   let newUrl = config.url.slice(5)
    //   config.url = process.env.VUE_APP_SQBS_API_URL + newUrl
    // }

    if (config.url.startsWith("/openapi")) {
      config.url = process.env.VUE_APP_OPENAPI_URL + config.url;
    } else if (config.url.startsWith("/api")) {
      config.url =
        process.env.VUE_APP_API_URL + config.url.replace(/\/api/, "");
    } else if (config.url.startsWith("/sqbs")) {
      let newUrl = config.url.slice(5);
      config.url = process.env.VUE_APP_SQBS_API_URL + newUrl;
    } else if (config.url.startsWith("/hermes")){
      config.url = process.env.VUE_APP_GATEWAY_URL + config.url;
    }
   

    //Mod by LiuHui at 20201201 for cros end
    // console.log(token)
    if (token) {
      config.headers.Authorization = "Bearer " + token; // 让每个请求携带自定义 token 请根据实际情况自行修改
    }
    console.log(config)
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(response => {
  // console.log(response)
  if (response.data.errorCode) {
    Message.error(response.data.errorMessage);
    // router.push('/login')
  } else {
    return response.data;
  }
}, err);

// 请求拦截  更改请求配置
// http.interceptors.request.use(
//   config => {
//     if (axios.defaults.baseURL === '') {
//       config.url = '/api' + config.url
//     }
//     // console.log(config)
//     return config
//   },
//   error => {
//     console.log(error)
//     return Promise.reject(error)
//   }
// )
// 响应拦截
// http.interceptors.response.use(function (response) {
//   // console.log(response)
//   const res = response.data
//   if (res.success && res.code === '200') {
//     return res.result
//   } else {
//     Vue.prototype.$message.error(res.message ? res.message : '网络异常，请稍后再试！')
//     throw Error()
//   }
// }, function (error) {
//   if (error.response.data.status === '500') {
//     Vue.prototype.$message.error(error.response.data.message)
//   } else {
//     Vue.prototype.$message.error(error)
//   }
//   // return Promise.reject(error.response.data);
//   throw Error()
// }
// )

// export default http
export { http as axios };
